<template>
  <div>
    <div v-if="isLoading" class="flex justify-center my-20">
      <loader-static size="40px" />
    </div>
    <div v-else-if="displayMenu" class="menu-section">
      <div v-if="!activeCategory" class="menu-section-list category-list">
        <div class="menu-section-list-item flex justify-between align-center pointer" @click="handleClick(null)">
          {{ categoryLink.name }}
          <Icon icon-key="chevron-right" hover-type="OPACITY" />
        </div>
        <div
          v-for="link in featuredLinks.view_components"
          :key="link.id"
          class="menu-section-list-item flex justify-between align-center pointer"
          @click="handleClick(link)"
        >
          {{ link.info.link_title }}
        </div>
      </div>
      <div v-else>
        <div class="mobile-menu">
          <div class="commands-container">
            <div class="back-container">
              <Icon icon-key="chevron-left" hover-type="OPACITY" :on-click="() => (activeCategory = false)" />
            </div>
            <Icon icon-key="close" hover-type="OPACITY" class="close-container" :on-click="onClose" />
          </div>
          <div class="scrollable">
            <div class="flex justify-start menu-content pb-10 pt-80">
              <div class="menu-section-list category-list">
                <div class="subheading-3 mb-20">{{ categoryLink.name }}</div>
                <div
                  v-for="category in categories.children_containers"
                  :key="category.id"
                  class="menu-section-list-item"
                >
                  <span
                    class="menu-section-list-item flex justify-between align-center pointer"
                    :data-test-id="`category_link_${category.name}`"
                    @click="navigateToCategory(category)"
                  >
                    {{ category.name }}
                  </span>
                </div>
              </div>
            </div>
            <div class="subheading-3 my-10 px-15">{{ collections.name }}</div>
            <div class="flex flex-wrap px-5">
              <div
                v-for="(collection, index) in collections.view_components"
                :key="collection.id"
                class="collection-container"
                @click="handleCollectionClick(collection)"
              >
                <img
                  class="collection-image"
                  :class="{
                    'top-rounded': index === 1,
                    rounded: index === 2
                  }"
                  :src="collection.info.image_url"
                  :alt="collection.info.name"
                />
                <span class="a2 mt-15 pointer">{{ collection.info.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { NavigationApi } from '@/api'
import { navigationHelper } from '../../mixin/navigationHelper'
import LoaderStatic from '../../shared/loader/loaderStatic.vue'
import session from '@/services/session'

export default {
  name: 'RetailerMobileMenu',
  components: { LoaderStatic },
  mixins: [navigationHelper],
  props: ['onClose'],
  data() {
    return {
      activeCategory: false,
      categoryLink: null,
      featuredLinks: null,
      categories: [],
      collections: [],
      isLoading: false
    }
  },
  computed: {
    displayMenu() {
      return this.categoryLink && this.featuredLinks
    }
  },
  mounted() {
    this.getNavitationLinks()
  },
  methods: {
    handleClick,
    handleCollectionClick,
    getNavitationLinks
  }
}

function handleClick(link) {
  if (!link) {
    this.activeCategory = true
  } else {
    this.onClose()
    const path = this.$utils.getPathFromUrl(link.info.url)
    if (path.startsWith('/')) {
      this.$router.push(path)
    } else {
      window.open(link.info.url, '_self')
    }
  }
}

function handleCollectionClick(collection) {
  if (collection.info.collection_type === 'collection') {
    this.$router.push({
      name: 'Collection',
      params: {
        collectionName: collection.info.collection_name,
        collectionId: collection.entity_id
      },
      query: { page: 1 }
    })
  } else {
    window.open(collection.info.url, '_self')
  }
}

async function getNavitationLinks() {
  try {
    this.isLoading = true
    const userInfo = session.getUserInfo()
    const userRole = session.getRole()

    const [links] = await NavigationApi.getNavigationV2({ role: userRole, userId: userInfo ? userInfo.id : null })
    this.categoryLink = links.children_containers.find((item) => item.container_type === 'NAVIGATION_V2')
    this.featuredLinks = links.children_containers.find((item) => item.container_type === 'FEATURED_LINKS_RETAILER')
    this.categories = this.categoryLink.children_containers.find(
      (item) => item.container_type === 'NAVIGATION_V2_CATEGORIES'
    )
    this.collections = this.categoryLink.children_containers.find(
      (item) => item.container_type === 'NAVIGATION_V2_COLLECTION'
    )
  } catch (error) {
    this.$handleError(this, error)
  } finally {
    this.isLoading = false
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/base/_vars.scss';
.commands-container {
  background: $color-white;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 60px;
}

.scrollable {
  height: 100vh;
  overflow-y: scroll;
}

.collection {
  &-container {
    display: flex;
    flex-direction: column;
    padding: 16px 8px;
    width: 50%;
    &:hover {
      opacity: 0.7;
    }
  }
  &-image {
    aspect-ratio: 0.9 / 1;
    border: 1px solid $color-black;
    cursor: pointer;
    &.rounded {
      border-radius: 16px;
    }
    &.top-rounded {
      border-top-left-radius: 50%;
      border-top-right-radius: 50%;
    }
  }
}
</style>

<style lang="scss" scoped src="./TheMainMobileMenu.scss" />
